require("@nfc/js/bootstrap");
window.moment = require("moment");

import moment from 'moment';

import { createApp } from "vue";
import router from "./router";
import Vuex from "vuex";

//import DatepickerBoostrap from "@nfc/views/components/DatepickerBoostrap";
//import DatepickerMaterial from "@nfc/views/components/DatepickerMaterial";
import LoadPreference from "@nfc/views/components/loadPreference";
import LoadPopup from "@nfc/views/marketing/emergentes/widget";
import autocomplete from "@nfc/views/components/Autocomplete";
import LoadLanguage from "@nfc/views/components/loadLanguage";
import datepicker from "@nfc/views/components/datepicker";
import LoadThemes from "@nfc/views/components/loadTheme";
import whatsapp from "@nfc/views/apps/whatsapp/widget";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import Directives from "@nfc/js/global/directives";
import ChatBot from "@nfc/views/apps/chat/widget";
import Methods from "@nfc/js/global/methods";
import Filters from "@nfc/js/global/filters";
import Lang from "@nfc/js/global/lang";
import store from "@nfc/js/store";

const app = createApp({});

app.component("Datepicker", datepicker);
app.component("Autocomplete", autocomplete);
// app.component("DatepickerBoostrap", DatepickerBoostrap);
// app.component("DatepickerMaterial", DatepickerMaterial);
app.component("Whatsapp", whatsapp);
app.component("ChatBot", ChatBot);
app.component("load-theme", LoadThemes);
app.component("load-language", LoadLanguage);
app.component("load-preference", LoadPreference);
app.component("load-popup", LoadPopup);
app.config.globalProperties.$moment = moment;

app.use(Directives);
app.use(Filters);
app.use(Methods);
app.use(router);
app.use(store);
app.use(Lang);
app.use(Vuex);
app.mount("#app");
